import Vue from 'vue';

export function getEventData(eventCategory, eventAction, eventCase) {
    if (!eventCase) {
        console.warn(`Cannot get event data for ${eventCategory}.${eventAction} since eventCase was empty`);

        return false;
    }

    let label;

    if (eventAction === 'caseStart') {
        label = `Case start (${eventCase.title})`;
    } else if (eventAction === 'caseEnd') {
        label = `Case end (${eventCase.title})`;
    }


    return {
        eventCategory: eventCategory,
        eventAction: eventAction,
        eventLabel: label,
        eventValue: eventCase.id
    };
}

export function postEventData(eventCategory, eventAction, eventCase) {
    let eventData = getEventData(eventCategory, eventAction, eventCase);

    if (!eventData) {
        //console.log('$ga.event - not posting event because eventData was FALSE');

        return false;
    }

    //console.log('$ga.event', eventData);

    return Vue.$ga.event(eventData);
}

export const eventCategories = {
    singlePlayer: 'singlePlayer', // The "singlePlayer" game type, playing the case yourself - will be executed for the player
    multiPlayer: 'multiPlayer', // The "classRoom" game type, playing with students - will be executed for the teacher
};

export const eventActions = {
    caseStart: 'caseStart', // Executed in the initial pages phase of a case for the teacher or single player
    caseEnd: 'caseEnd', // Executed in the end phase of a case for the teacher or single player
};